
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { TAnswerBlock } from "@/modules/Questionnaire/components/AnswerBlocks/TAnswerBlocks";
import { SMQuestionnaire, SMCases, SMTasks, SMHorizontalQuestionnaire } from "@/store";
import InlineLoader from "@/components/InlineLoader/InlineLoader.vue";

const MESSAGES = {
  placeholders: {
    jobTitle: "Job title",
  },
};

const INPUT_OPTIONS = {
  label: MESSAGES.placeholders.jobTitle,
};

const INPUT_OPTION_MODEL = { label: "", value: "" };

const DISPLAY_NAME_CREATE = "Create a job template";

export type JobTitleOption = {
  label: string | unknown | undefined;
  value: string | unknown | undefined;
};
@Component({
  components: {
    InlineLoader,
  },
})
export default class AnswerBlockJobTitleSelect extends Vue {
  @Prop({ type: Object, default: () => ({}) }) readonly answerBlockData!: TAnswerBlock;
  @Prop({ type: Number, default: () => 0 }) readonly index: number | undefined;
  @Prop({ type: Number, default: () => 0 }) readonly loopIndex: number | undefined;

  messages = MESSAGES;

  get inputProps() {
    return { ...INPUT_OPTIONS };
  }

  input = "";

  inputOptionModel = INPUT_OPTION_MODEL;

  isInputShown = false;

  @Watch("input")
  updateAnswer(value: string) {
    const { index, answerBlockData, loopIndex } = this;

    if (index == null) return;

    SMQuestionnaire.updateAnswer({
      index,
      value,
      required: answerBlockData.is_required,
      answer_block_id: answerBlockData.ID,
      loop_index: loopIndex,
      condition: answerBlockData.condition,
    });

    // window.sessionStorage.setItem(`alias.${answerBlockData.alias}`, this.query);
  }

  soc_code = "";

  get taskId() {
    const { taskId } = this.$route.params;

    return taskId ? Number(taskId) : SMHorizontalQuestionnaire.taskId;
  }

  async getSocCodeGroupNumber() {
    const case_id = SMCases.caseId;

    const alias = SMQuestionnaire.socGroupNumberAnswerBlockAlias;

    let params: object;

    if (SMQuestionnaire.display_name === DISPLAY_NAME_CREATE) {
      params = {
        alias,
        ...SMQuestionnaire.getAnswerQuery,
      };
    } else {
      params = {
        alias,
        case_id,
        task_id: this.taskId,
      };

      const targetId = this.$route.params.id || SMTasks.targetUserId;

      if (targetId) {
        Object.assign(params, {
          target_id: targetId,
        });
      }
    }

    const { data } = await this.axios.get(API_ROUTES.GET_ANSWER_BLOCK(), { params });

    if (!data?.alias_result || data.alias_result === "record not found") return;

    this.soc_code = data.alias_result;
  }

  query = "";

  @Watch("query")
  onQueryUpdate(val: string): void {
    if (!val) return;

    this.unsetSelection();

    this.input = val;
  }

  selection = "";
  options: JobTitleOption[] = [];

  unsetSelection() {
    this.selection = "";
  }

  resetSelection() {
    this.selection = null;
  }

  loading = false;

  async fetchOptions(soc_code: string | number) {
    if (!soc_code) return;

    try {
      this.loading = true;

      const { data } = await this.axios.get(API_ROUTES.GET_SOC_ITEM(soc_code));

      if (!data || !data.job_titles?.length) return;

      this.isInputShown = !data.d_and_n;

      const jobTitles = [...new Set(data.job_titles)];

      this.options = jobTitles.reduce((acc: JobTitleOption[], cur) => {
        if (cur) acc.push({ label: cur, value: cur });

        return acc;
      }, []);
    } finally {
      this.loading = false;
    }
  }

  @Watch("selection")
  onSelectionUpdate(val: string): void {
    if (!val) return;

    this.input = val;
  }

  setAnswer(value: string) {
    if (!value) return;

    const optionValues = this.options.map((option) => option.value);

    if (this.options.length && optionValues.includes(value)) this.selection = value;

    this.input = value;
  }

  focusToInput() {
    const target = (this.$refs.queryInput as Vue)?.$el;

    if (!target) return;

    const input = target.querySelector("input[type='text']");

    if (!input) return;

    (input as HTMLElement).focus();
  }

  getAnswerBlockData() {
    const answer = SMQuestionnaire.answers.find(
      (answer) =>
        answer.answer_block_id === this.answerBlockData.ID && this.loopIndex === answer.loop_index
    );

    if (!answer) return;

    if (this.options.find((option) => option.value === answer.value))
      return (this.selection = answer.value);

    this.query = answer.value;
  }

  async created() {
    await this.getSocCodeGroupNumber();

    await this.fetchOptions(this.soc_code);

    await this.$nextTick();

    this.resetSelection();

    this.getAnswerBlockData();

    // DEV-1580. Hide for current needs. Then uncomment;
    // this.setAnswer(this.query);
  }
}
